import StatusBadgeM from "@common/components/badge/StatusBadgeM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import React from "react"
import { View } from "react-native"
import {
    hasTutorChange,
    IMPACT_TITLE,
    impactDetails,
    impactStatusLabel,
    isTutorChange,
    TUTOR_CHANGE_CONSEQUENCE,
} from "./absenceImpact"

/**
 * L'impact de l'absence, élève par élève, affiché AVANT la confirmation —
 * seulement quand un élève change de masteur : sinon l'écran reste celui
 * d'avant. Un bloc ; pour chaque élève une pastille et le pourquoi ; une
 * phrase de fin.
 */
export default function AbsenceImpactComponent({ students, width }) {
    if (!hasTutorChange(students)) return null

    return (
        <View
            style={{
                width,
                alignSelf: "flex-start",
                marginTop: 4,
                marginBottom: 8,
                paddingVertical: 12,
                paddingHorizontal: 14,
                borderRadius: 16,
                borderWidth: 1,
                borderColor: theme.colors.lightMore,
                backgroundColor: theme.colors.white,
            }}
        >
            <TextM fontWeight={"SemiBold"} fontSize={13} color={theme.colors.greyAlt}>
                {IMPACT_TITLE}
            </TextM>
            {students.map((student) => {
                const change = isTutorChange(student)

                return (
                    <View
                        key={student.id}
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginTop: 10,
                        }}
                    >
                        <View style={{ flexShrink: 1, marginRight: 8 }}>
                            <TextM fontWeight={"SemiBold"}>{student.firstname}</TextM>
                            {impactDetails(student).map((line) => (
                                <TextM
                                    key={line}
                                    wrap
                                    fontSize={12}
                                    color={theme.colors.greyAlt}
                                    style={{ marginTop: 2 }}
                                >
                                    {line}
                                </TextM>
                            ))}
                        </View>
                        <StatusBadgeM
                            icon={change ? "exchange-alt" : null}
                            label={impactStatusLabel(student)}
                            color={change ? theme.colors.error : theme.colors.greyAlt}
                            backgroundColor={
                                change ? theme.colors.errorLight : theme.colors.lighter
                            }
                            fontSize={11}
                        />
                    </View>
                )
            })}
            <TextM
                wrap
                style={{
                    marginTop: 12,
                    paddingTop: 10,
                    borderTopWidth: 1,
                    borderTopColor: theme.colors.lighter,
                    lineHeight: 18,
                }}
            >
                {TUTOR_CHANGE_CONSEQUENCE}
            </TextM>
        </View>
    )
}
